import React from "react";
import { LineItemElementProps } from "../types";
import TopMostPortal from "../../../../components/ui/utils/Portals";
import { LineItemPreviewPanel } from "./LineItemPreviewPanel";
import { LineItemCategory } from "@rebuild/shared";
import { ScopeTag, getScopeTagDisplayName } from "../../MappingTool/utils/ScopeTag";

interface Props {
	lineItemToProcess: LineItemElementProps[];
	selectedCategory: string;
	onCategoryChange: (val: string) => void;
	selectedScopes: string[];
	onScopesChange: (scopes: string[]) => void;
	onCancel: () => void;
	onSave: () => Promise<void>;
}

const SavePreviewModal: React.FC<Props> = ({
	lineItemToProcess,
	selectedCategory,
	onCategoryChange,
	selectedScopes,
	onScopesChange,
	onCancel,
	onSave,
}) => {
	return (
		<TopMostPortal>
			<div className="w-[880px] min-h-[360px] bg-white rounded-xl shadow flex-col justify-between items-center flex">
				<div className="self-stretch h-[76px] bg-white flex-col justify-start items-center flex">
					<div className="self-stretch px-6 pt-6 bg-white justify-start items-start gap-4 inline-flex">
						<div className="grow shrink basis-0 flex-col justify-start items-start gap-1 inline-flex">
							<div className="self-stretch text-gray-900 text-2xl font-normal font-['Hanken Grotesk'] leading-loose">
								Preview line item
							</div>
						</div>
					</div>
					<div className="p-2.5 rounded-lg justify-center items-center inline-flex">
						<div className="w-6 h-6 relative" />
					</div>
					<div className="self-stretch h-5" />
				</div>
				<div className="w-[880px]  px-6 py-8 bg-gray-100 flex-col justify-start items-center inline-flex">
					<div className=" flex-col justify-center items-center gap-0.5 flex">
						<div className="self-stretch  flex-row justify-center items-center gap-1.5 flex">
							<div className="text-slate-700 text-sm font-medium font-['Hanken Grotesk'] leading-tight">Select line item category</div>
							<select
								className="rounded p-2 focus:outline-none"
								value={selectedCategory}
								onChange={(e) => onCategoryChange(e.target.value)}
							>
								{Object.values(LineItemCategory).map((category) => {
									return (
										<option key={category} value={category}>
											{category}
										</option>
									);
								})}
							</select>
						</div>
						<div className="self-stretch flex-col justify-center items-center gap-1.5 flex mt-4">
							<div className="text-slate-700 text-sm font-medium font-['Hanken Grotesk'] leading-tight">
								Scopes (optional - select multiple)
							</div>
							<div className="flex flex-col gap-2 mt-2">
								{Object.values(ScopeTag).map((scope) => (
									<label key={scope} className="flex items-center gap-2">
										<input
											type="checkbox"
											checked={selectedScopes.includes(scope)}
											onChange={(e) => {
												if (e.target.checked) {
													onScopesChange([...selectedScopes, scope]);
												} else {
													onScopesChange(selectedScopes.filter((s) => s !== scope));
												}
											}}
											className="w-4 h-4"
										/>
										<span className="text-sm">{getScopeTagDisplayName(scope)}</span>
									</label>
								))}
							</div>
						</div>
					</div>
				</div>
				<div className="self-stretch px-6 py-8 justify-start items-start gap-4 inline-flex min-h-[200px] max-h-[500px] overflow-y-scroll">
					<LineItemPreviewPanel lineItemToProcess={lineItemToProcess} />
				</div>
				<div className="self-stretch h-[68px] flex-col justify-center items-start flex">
					<div className="self-stretch px-6 pb-6 justify-start items-center gap-3 inline-flex">
						<div className="grow shrink basis-0 h-11 justify-between items-center flex">
							<div
								className="px-[18px] py-2.5 bg-white rounded-lg border border-gray-200 justify-center items-center gap-2 flex cursor-pointer"
								onClick={onCancel}
							>
								<div className="justify-start items-center gap-2 flex ">
									<div className="text-slate-700 text-base font-semibold font-['Hanken Grotesk'] leading-normal">Cancel</div>
								</div>
							</div>
							<div
								className="px-[18px] py-2.5 bg-blue-900 rounded-lg shadow border border-blue-900 justify-center items-center gap-2 flex cursor-pointer"
								onClick={onSave}
							>
								<div className="justify-start items-center gap-2 flex">
									<div className="text-white text-base font-semibold font-['Hanken Grotesk'] leading-normal">Save</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</TopMostPortal>
	);
};

export default SavePreviewModal;
